export default __webpack_public_path__ + "static/media/blank-profile.0334f4b4.png";